import moment from "moment";
import 'moment/locale/pl';

export default function () {
    const updateTimestamp = (ls) => {
        if (!ls.getAttribute('data-livestamp')) return;
        const timestamp = +ls.getAttribute('data-livestamp') * 1000;
        ls.innerHTML = moment(timestamp).fromNow();
    };

    const initLiveStamps = (parent = document) => {
        parent.querySelectorAll('[data-livestamp]').forEach(ls => {
            updateTimestamp(ls);
            if (!ls._interval) { // żeby nie tworzyć podwójnych intervali
                ls._interval = setInterval(() => updateTimestamp(ls), 30000);
            }
        });
    };

    // inicjalizacja na start
    initLiveStamps();

    // obserwowanie nowych elementów w DOM
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // element
                    initLiveStamps(node);
                }
            });
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });
}